import React from 'react'
import UserDetails from 'containers/UserDetails'
import { ContainerGeral } from './Styled'
import BannerPrincipal from './Components/BannerPrincipal/BannerPrincipal'
import ItensInclusos from './Components/ItensInclusos/ItensInclusos'
import Depoimentos from './Components/Depoimentos/Depoimentos'
import TextoFinal from './Components/TextoFinal/TextoFinal'
import ImagemMobile from './Components/ImagemMobile/ImagemMobile'

export default function PosCNU2025 () {

  return (
    <UserDetails showSpinner>
		{details => {

			return (
				<ContainerGeral padding={false}>
					
					{/* Banner Principal */}
					<BannerPrincipal planos={details.renovar_assinatura_antecipada.planos} />

					{/* Itens Inclusos */}
					<ItensInclusos planos={details.renovar_assinatura_antecipada.planos[0].assinaturas[0]} />

					{/* Depoimentos */}
					<Depoimentos />

					{/* Texto Final */}
					<TextoFinal />

					{/* Imagem mobile */}
					<ImagemMobile />

				</ContainerGeral>
			)
			
		}}
    </UserDetails>
  )
}
